import CookieUtils from "../../../interfaces/CookieUtils";
import { editableCookieTypeKeys } from "./CustomizeCookiePreferences/data";

export const setCookieAndHandleTracking = (propsData, eventActionName, cookieValue, cookiesData = null) => {
  CookieUtils.setCookie(propsData.consentConstants.cookieNames.cookieConsent, CookieUtils.getCookieValueToSet(editableCookieTypeKeys, cookieValue, cookiesData));
  CookieUtils.handleAnalyticalTracking(cookieValue, propsData.gaMeasurementId);
  CookieUtils.handleEventTracking(eventActionName, cookiesData);
}

export const handleManageCookiesButtonClick = (showModal) => {
  showModal();
  CookieUtils.handleEventTracking(chrEventConstants.action.CLICKED_MANAGE_COOKIES);
}